import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/page', Object.assign({}, options, { params }));

export const lastEndTime = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/lastEndTime', Object.assign({}, options, { params }));

export const getCouponAmount = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/couponAmount', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/park/coupon/balance/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/coupon/balance/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/coupon/balance/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/park/coupon/balance/submit', params,options);
